import produce from 'immer'
import { CaseworkerActionType } from '../../action-types'
import { CaseworkerAction } from '../../actions'

export interface CaseworkerStatusState {
    loading: boolean
    error: string | null
}

const initialState: CaseworkerStatusState = {
    loading: false,
    error: null,
}

const reducer = produce(
    (state: CaseworkerStatusState = initialState, action: CaseworkerAction) => {
        switch (action.type) {
            case CaseworkerActionType.SET_CASEWORKER_LOADING:
                state.loading = true
                return state

            case CaseworkerActionType.SET_CASEWORKER_ERROR:
                state.loading = false
                state.error = action.payload.message
                return state

            case CaseworkerActionType.GET_ORGANIZATIONS:
            case CaseworkerActionType.GET_OWN_REPORTS:
            case CaseworkerActionType.GET_ALL_REPORTS:
            case CaseworkerActionType.GET_CLOSED_REPORTS:
            case CaseworkerActionType.GET_CLIENT_INFORMATION:
            case CaseworkerActionType.GET_SELF:
            case CaseworkerActionType.GET_SELF_ORGANIZATION:
            case CaseworkerActionType.ADD_CASEWORKER:
            case CaseworkerActionType.GET_ALL_CASEWORKERS:
            case CaseworkerActionType.GET_SINGLE_CASEWORKER:
            case CaseworkerActionType.ADD_CASEWORKER_VALIDATION:
            case CaseworkerActionType.SHOW_CREATE_CASEWORKER_VALIDATION_ERRORS:
                state.loading = false
                state.error = null
                return state

            default:
                return state
        }
    }
)

export default reducer
